/**
 * `getCallerOrgId` / `withCallerOrg`
 *
 * Phase E (May 6, 2026): file canonical home moved to
 * `shared/utils/callerOrg.js`. The legacy path `@/utils/callerOrg`
 * continues to work via a thin re-export.
 *
 * Small helper: read the caller's organizationId from localStorage so
 * we can append `?organizationId=...` to public settings endpoints
 * (design flow, generate-design, review, etc.). Returns null when no
 * user is logged in — the backend falls back to `org-default` in that
 * case.
 *
 * Kept purposely dependency-free so it can be imported from any
 * feature module without pulling in the zustand store.
 */
export const getCallerOrgId = () => {
  try {
    const raw = localStorage.getItem('eoc-current-user');
    if (!raw) return null;
    const u = JSON.parse(raw);
    return u && u.organizationId ? String(u.organizationId) : null;
  } catch {
    return null;
  }
};

/**
 * Append `organizationId=<caller>` to a relative /api/public/... URL.
 * Safe to call even when anonymous (returns the URL unchanged).
 */
export const withCallerOrg = (url) => {
  const orgId = getCallerOrgId();
  if (!orgId) return url;
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}organizationId=${encodeURIComponent(orgId)}`;
};
